<!-- /* * Confidential and Proprietary. * Do not distribute without 1-800-Flowers.com, Inc. consent. *
Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved. */ -->

<div class="chat-messages" data-testid="chat-messages">
	<div class="message-container">
		<ChatPrivacyNotice />
	</div>
	{#if $chatSession.messages.length !== 0}
		{#each $chatSession.messages as message, idx}
			{#if message.params?.product_options?.length}
				<div class="message-container">
					{#if message.sender === 'bot' || message.sender === 'agent'}
						{#if message.sender === 'bot'}
							<img class="bot-icon" src="floraIconUpdate.svg" alt="logo" />
						{:else}
							<img class="bot-icon" src="customerService.svg" alt="logo" />
						{/if}
						<div class="message bot">
							<SvelteMarkdown
								source={message.message}
								renderers={{ link: markdownUrlRedirect }}
								isInline
							/>
						</div>
					{:else}
						<div class="message customer">{message.message}</div>
					{/if}
				</div>
				{#if message.params?.moreProductsRequested}
					<div class="product-grid2">
						{#each message.params.product_options as item}
							<ChatProductDisplayViewMore {handleClickProduct} product={item || {}} />
						{/each}
					</div>
				{:else}
					{#each message.params.product_options as item}
						<ChatProductDisplay {handleClickProduct} product={item || {}} />
					{/each}
				{/if}
				{#if message?.params?.suggestions && !clickedSuggestions[idx]}
					<div class="message-container bot">
						<div class="suggestions-product">
							{#each message.params.suggestions as item}
								<button
									class="suggestion-button"
									on:click={() => {
										if (
											item.suggestion?.toLowerCase() === 'show me more options like this' ||
											item.suggestion?.toLowerCase() === 'show me something different'
										) {
											handleClickMore(
												item.suggestion,
												$chatSession?.messages[$chatSession.messages.length - 1]?.params
													?.product_options[Math.floor(Math.random() * 4)].name
											);
										} else {
											handleSuggestionClick(item.suggestion, idx, item);
										}
									}}
								>
									<SvelteMarkdown
										source={item.suggestion}
										renderers={{ link: markdownUrlRedirect }}
										isInline
									/>
								</button>
							{/each}
						</div>
					</div>
				{/if}
			{:else if message?.params?.survey_link}
				<div class="message-container bot">
					{#if message.sender === 'bot'}
						<img class="bot-icon" src="floraIconUpdate.svg" alt="logo" />
					{:else}
						<img class="bot-icon" src="customerService.svg" alt="logo" />
					{/if}
					<div class="message bot">
						<SvelteMarkdown
							source={message.message}
							renderers={{ link: markdownUrlRedirect }}
							isInline
						/>
					</div>
				</div>
				{#if $chatSession.flags?.['flora-quick-csat-enabled']}
					<div>
						<ChatQuickCsatRating href={message.params.survey_link} />
					</div>
				{:else}
					<div class="message-container bot">
						<SurveyButton href={message.params.survey_link} />
					</div>
				{/if}
			{:else if message.params?.order_options?.length}
				<div class="message-container bot">
					<img class="bot-icon" src="floraIconUpdate.svg" alt="logo" />
					<div class="message-content">
						<div class="message bot">
							<SvelteMarkdown
								source={message.message}
								renderers={{ link: markdownUrlRedirect }}
								isInline
							/>
						</div>
						{#each message.params?.order_options as orderOption}
							<button
								class="status-card {clickedOrders?.[idx] ||
								idx !== $chatSession.messages.length - 1 ||
								$surveySent
									? 'clicked'
									: ''}"
								on:click={() =>
									!clickedOrders?.[idx] &&
									!$surveySent &&
									handleOrderOptionsClick(orderOption.order_number, idx, orderOption)}
							>
								{#key orderOption}
									<ChatStatusDisplay order={orderOption} />
								{/key}
							</button>
						{/each}
						{#if message?.params?.suggestions && !clickedSuggestions[idx]}
							<div class="suggestions">
								{#each message.params.suggestions as item}
									<button
										class="suggestion-button"
										on:click={() => handleSuggestionClick(item.suggestion, idx, item)}
									>
										<SvelteMarkdown
											source={item.suggestion}
											renderers={{ link: markdownUrlRedirect }}
											isInline
										/>
									</button>
								{/each}
							</div>
						{/if}
					</div>
				</div>
			{:else if message?.params?.suggestions && !clickedSuggestions[idx]}
				<div class="message-container bot">
					<img class="bot-icon" src="floraIconUpdate.svg" alt="logo" />
					<div class="message-content">
						<div class="message bot">
							<SvelteMarkdown
								source={message.message}
								renderers={{ link: markdownUrlRedirect }}
								isInline
							/>
						</div>
						<div class="suggestions">
							{#each message.params.suggestions as item}
								<button
									class="suggestion-button"
									on:click={() => handleSuggestionClick(item.suggestion, idx, item)}
								>
									<div>
										<SvelteMarkdown
											source={item.suggestion}
											renderers={{ link: markdownUrlRedirect }}
											isInline
										/>
									</div>
								</button>
							{/each}
						</div>
					</div>
				</div>
			{:else if (message.sender === 'bot' || message.sender === 'agent') && message.message !== ''}
				<div class="message-container bot">
					{#if message.sender === 'bot'}
						<img class="bot-icon" src="floraIconUpdate.svg" alt="logo" />
					{:else}
						<img class="bot-icon" src="customerService.svg" alt="logo" />
					{/if}
					<div class="message bot">
						<SvelteMarkdown
							source={message.message}
							renderers={{ link: markdownUrlRedirect }}
							isInline
						/>
					</div>
				</div>
			{:else if message.message !== ''}
				<div class="message-container">
					<div class="message customer">{message.message}</div>
				</div>
			{:else if message.message === '' && message.params?.['isSelectedOrderOption']?.['order_number']}
				<div class="message-container">
					<div class="customer-order-selection-card">
						<svg width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
							<g data-name="Layer 2">
								<g data-name="checkmark-circle-2">
									<rect width="24" height="24" opacity="0" />
									<path
										fill="#43A047"
										d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z"
									/>
									<path
										fill="#43A047"
										d="M14.7 8.39l-3.78 5-1.63-2.11a1 1 0 0 0-1.58 1.23l2.43 3.11a1 1 0 0 0 .79.38 1 1 0 0 0 .79-.39l4.57-6a1 1 0 1 0-1.6-1.22z"
									/>
								</g>
							</g>
						</svg>
						<div class="customer-order-selection-text">
							<div class="customer-order-selection-subtitle">
								ORDER: {message.params?.['isSelectedOrderOption']?.order_number}
							</div>
							<div class="customer-order-selection-subtitle">
								ITEM: {message.params?.['isSelectedOrderOption']?.product_name}
							</div>
						</div>
					</div>
				</div>
			{/if}
			{#if message.sender !== 'agent' && message.message !== '' && !message?.params?.survey_link}
				<ChatFeedbackButtons {messageReaction} {message} {idx} />
			{/if}
		{/each}
	{:else}
		{#each $chatSession.chatHistory as message, idx}
			{#if message.params?.product_options?.length}
				<div class="message-container">
					{#if message.sender === 'bot' || message.sender === 'agent'}
						{#if message.sender === 'bot'}
							<img class="bot-icon" src="floraIconUpdate.svg" alt="logo" />
						{:else}
							<img class="bot-icon" src="customerService.svg" alt="logo" />
						{/if}
						<div class="message bot">
							<SvelteMarkdown
								source={message.message}
								renderers={{ link: markdownUrlRedirect }}
								isInline
							/>
						</div>
					{:else}
						<div class="message customer">{message.message}</div>
					{/if}
				</div>
				{#if message.params?.moreProductsRequested}
					<div class="product-grid2">
						{#each message.params.product_options as item}
							<ChatProductDisplayViewMore {handleClickProduct} product={item || {}} />
						{/each}
					</div>
				{:else}
					{#each message.params.product_options as item}
						<ChatProductDisplay {handleClickProduct} product={item || {}} />
					{/each}
				{/if}
			{:else if message.params?.order_options?.length}
				<div class="message-container bot">
					<img class="bot-icon" src="floraIconUpdate.svg" alt="logo" />
					<div class="message-content">
						<div class="message bot">
							<SvelteMarkdown
								source={message.message}
								renderers={{ link: markdownUrlRedirect }}
								isInline
							/>
						</div>
						{#each message.params?.order_options as orderOption}
							<button
								class="status-card {clickedOrders?.[idx] ||
								idx !== $chatSession.messages.length - 1 ||
								$surveySent
									? 'clicked'
									: ''}"
								on:click={() =>
									!clickedOrders?.[idx] &&
									!$surveySent &&
									handleOrderOptionsClick(orderOption.order_number, idx, orderOption)}
							>
								<ChatStatusDisplay order={orderOption} />
							</button>
						{/each}
						{#if message?.params?.suggestions && !clickedSuggestions[idx]}
							<div class="suggestions">
								{#each message.params.suggestions as item}
									<button
										class="suggestion-button"
										on:click={() => handleSuggestionClick(item.suggestion, idx, item)}
									>
										<SvelteMarkdown
											source={item.suggestion}
											renderers={{ link: markdownUrlRedirect }}
											isInline
										/>
									</button>
								{/each}
							</div>
						{/if}
					</div>
				</div>
			{:else if message?.params?.suggestions && !clickedSuggestions[idx]}
				<div class="message-container bot">
					<img class="bot-icon" src="floraIconUpdate.svg" alt="logo" />
					<div class="message-content">
						<div class="message bot">
							<SvelteMarkdown
								source={message.message}
								renderers={{ link: markdownUrlRedirect }}
								isInline
							/>
						</div>
						<div class="suggestions">
							{#each message.params.suggestions as item}
								<button
									class="suggestion-button"
									on:click={() => handleSuggestionClick(item.suggestion, idx, item)}
								>
									<SvelteMarkdown
										source={item.suggestion}
										renderers={{ link: markdownUrlRedirect }}
										isInline
									/>
								</button>
							{/each}
						</div>
					</div>
				</div>
			{:else if (message.sender === 'bot' || message.sender === 'agent') && message.message !== ''}
				<div class="message-container bot">
					{#if message.sender === 'bot'}
						<img class="bot-icon" src="floraIconUpdate.svg" alt="logo" />
					{:else}
						<img class="bot-icon" src="customerService.svg" alt="logo" />
					{/if}
					<div class="message bot">
						<SvelteMarkdown
							source={message.message}
							renderers={{ link: markdownUrlRedirect }}
							isInline
						/>
					</div>
				</div>
			{:else if message.message !== ''}
				<div class="message-container">
					<div class="message customer">{message.message}</div>
				</div>
			{:else if message.message === '' && message.params?.['isSelectedOrderOption']}
				<div class="message-container">
					<div class="customer-order-selection-card">
						<svg width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
							<g data-name="Layer 2">
								<g data-name="checkmark-circle-2">
									<rect width="24" height="24" opacity="0" />
									<path
										fill="#43A047"
										d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z"
									/>
									<path
										fill="#43A047"
										d="M14.7 8.39l-3.78 5-1.63-2.11a1 1 0 0 0-1.58 1.23l2.43 3.11a1 1 0 0 0 .79.38 1 1 0 0 0 .79-.39l4.57-6a1 1 0 1 0-1.6-1.22z"
									/>
								</g>
							</g>
						</svg>
						<div class="customer-order-selection-text">
							<div class="customer-order-selection-subtitle">
								ORDER: {message.params?.['isSelectedOrderOption']?.order_number}
							</div>
							<div class="customer-order-selection-subtitle">
								ITEM: {message.params?.['isSelectedOrderOption']?.product_name}
							</div>
						</div>
					</div>
					<div class="message customer">{message.message}</div>
				</div>
			{/if}
			{#if message.sender !== 'agent' && message.message !== '' && !message?.params?.survey_link}
				<ChatFeedbackButtons {messageReaction} {message} {idx} />
			{/if}
		{/each}
	{/if}
	<ChatTyping {typing} />
	<div bind:this={scrollTarget}></div>
</div>

<script lang="ts">
	import { writable, type Writable } from 'svelte/store';
	import SvelteMarkdown from 'svelte-markdown';
	import { onMount, afterUpdate } from 'svelte';
	import { notificationSoundEnabled } from '$lib/stores/chatSessionStore';
	import { chatSession, messageLoading, surveySent } from '$lib/stores/chatSessionStore';
	import ChatProductDisplay from '$lib/components/chat/ChatProductDisplay.svelte';
	import ChatProductDisplayViewMore from '$lib/components/chat/ChatProductDisplayViewMore.svelte';
	import { sendMessage } from '$lib/apis/webchat/sendMessage';
	import { soundNotification } from '$lib/utilities/soundNotification';
	import ChatPrivacyNotice from './ChatPrivacyNotice.svelte';
	import ChatTyping from './ChatTyping.svelte';
	import ChatFeedbackButtons from './ChatFeedbackButtons.svelte';
	import SurveyButton from '$lib/components/chat/SurveyButton.svelte';
	import type {
		OrderOptionsObject,
		ProductObject,
		SuggestionsObject
	} from '$lib/apis/webchat/type';
	import ChatStatusDisplay from './ChatStatusDisplay.svelte';
	import markdownUrlRedirect from '../helpers/markdownLink.svelte';
	import ChatQuickCsatRating from './ChatQuickCSATRating.svelte';
	import { datadogLogs } from '@datadog/browser-logs';
	import { floraChatEventTracking } from '$lib/utilities/analytics';

	export let typing: Writable<boolean>;
	export let clickedSuggestions: { [key: string]: boolean };
	export let clickedOrders: { [key: string]: string };
	export let clearSuggestionsInMessages: (
		messages: typeof $chatSession.messages
	) => typeof $chatSession.messages;

	let scrollTarget: HTMLElement | null = null;
	$: {
		const lastMessage = $chatSession.messages[$chatSession.messages.length - 1];
		if (lastMessage?.params?.product_options?.length) {
			// dont do anything.
		} else if (scrollTarget && ($chatSession.messages.length || $typing)) {
			scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'end' });
		}
	}
	let messageReaction = writable(-1);

	const { play } = soundNotification('./ding.mp3');

	const handleSuggestionClick = async (
		customerSelectedOption: string,
		idx: number,
		suggestionObject: SuggestionsObject
	) => {
		const errorSuggestionClicked = customerSelectedOption === 'Retry Last Response';
		const lastCustomerMessage = $chatSession.messages
			.slice()
			.reverse()
			.find((item) => item.sender === 'customer')?.message;
		if (!$messageLoading) {
			clickedSuggestions[idx] = true;
			messageLoading.set(true);
			datadogLogs.logger.info(
				`[Conv-ui] Suggestion Clicked - brand: ${$chatSession.brand} channel: ${$chatSession.channel} browser_uuid: ${$chatSession.browseruuid} conversation_id: ${$chatSession?.conversation_id} selected_suggestion: ${customerSelectedOption} suggestions_offered: ${JSON.stringify($chatSession.messages[$chatSession.messages.length - 1]?.params?.suggestions)}`
			);
			chatSession.update((old) => {
				return {
					...old,
					messages: [
						...clearSuggestionsInMessages(old.messages),
						{
							sender: 'customer',
							message: customerSelectedOption,
							type: 'text',
							params: {}
						}
					]
				};
			});
			typing.set(true);
			const returnValue = await sendMessage(
				{
					conversation_id: $chatSession.conversation_id,
					brand_code: $chatSession.brand,
					channel: $chatSession.channel,
					message: errorSuggestionClicked
						? (lastCustomerMessage as string)
						: customerSelectedOption,
					type: 'text',
					params: {
						selected_option: {
							type: 'suggestions',
							suggestions:
								$chatSession.messages[$chatSession.messages.length - 2]?.params?.suggestions,
							selectedSuggestion: suggestionObject
						},
						typing: false,
						passport: {
							passportStatus: !!$chatSession?.passportEndDate
						},
						customer: {
							email: $chatSession.email,
							contact_id: $chatSession.contactId,
							browser_uuid: $chatSession.browseruuid,
							first: $chatSession.firstName,
							last: $chatSession.lastName
						}
					}
				},
				$chatSession.token
			);
			typing.set(false);
			chatSession.update((old) => {
				const updatedSession = {
					...old,
					messages: [
						...clearSuggestionsInMessages(old.messages),
						{
							sender: 'bot',
							message: returnValue?.message,
							type: returnValue?.type,
							params: returnValue?.params || {}
						}
					],
					chatHistory: returnValue?.params.conversation_history || old.chatHistory
				};
				sessionStorage.setItem('conversation', JSON.stringify(updatedSession));
				return updatedSession;
			});
			if ($notificationSoundEnabled) play();
			messageLoading.set(false);
		}
		floraChatEventTracking(
			$chatSession.conversation_id || 'N/A',
			'suggestionClicked',
			customerSelectedOption
		);
	};

	const handleOrderOptionsClick = async (
		customerSelectedOption: string,
		idx: number,
		orderOption: OrderOptionsObject
	) => {
		if (!$messageLoading) {
			clickedOrders = {
				...clickedOrders,
				[idx]: orderOption?.int_order_number
			};
			datadogLogs.logger.info(
				`[Conv-ui] Order Options Clicked - brand: ${$chatSession.brand} channel: ${$chatSession.channel} browser_uuid: ${$chatSession.browseruuid} conversation_id: ${$chatSession?.conversation_id} order_selected: ${customerSelectedOption} orders_presented: ${JSON.stringify($chatSession.messages[$chatSession.messages.length - 1]?.params?.order_options)}`
			);
			chatSession.update((old) => {
				const updatedSession = {
					...old,
					messages: [
						...clearSuggestionsInMessages(old.messages),
						{
							sender: 'customer',
							message: '',
							type: 'text',
							params: {
								isSelectedOrderOption: {
									order_number: orderOption.order_number,
									product_name: orderOption.product_name
								}
							}
						}
					]
				};
				if (updatedSession.messages?.[idx]?.params?.order_options?.length)
					updatedSession.messages[idx].params.order_options = [orderOption];
				sessionStorage.setItem('conversation', JSON.stringify(updatedSession));
				return updatedSession;
			});
			messageLoading.set(true);
			typing.set(true);
			const returnValue = await sendMessage(
				{
					conversation_id: $chatSession.conversation_id,
					brand_code: $chatSession.brand,
					channel: $chatSession.channel,
					message: `The order number is ${customerSelectedOption}`,
					type: 'text',
					params: {
						selected_option: {
							type: 'order_options',
							selectedOrder: orderOption,
							ordersPresented:
								$chatSession.messages[$chatSession.messages.length - 2]?.params?.order_options
						},
						typing: false,
						passport: {
							passportStatus: !!$chatSession?.passportEndDate
						},
						customer: {
							email: $chatSession.email,
							contact_id: $chatSession.contactId,
							browser_uuid: $chatSession.browseruuid,
							first: $chatSession.firstName,
							last: $chatSession.lastName
						}
					}
				},
				$chatSession.token
			);
			typing.set(false);
			chatSession.update((old) => {
				const updatedSession = {
					...old,
					messages: [
						...clearSuggestionsInMessages(old.messages),
						{
							sender: 'bot',
							message: returnValue?.message,
							type: returnValue?.type,
							params: returnValue?.params || {}
						}
					],
					chatHistory: returnValue?.params.conversation_history || old.chatHistory
				};
				if (updatedSession.messages?.[idx]?.params?.order_options?.length)
					updatedSession.messages[idx].params.order_options = [orderOption];
				sessionStorage.setItem('conversation', JSON.stringify(updatedSession));
				return updatedSession;
			});
			if ($notificationSoundEnabled) play();
			messageLoading.set(false);
			floraChatEventTracking(
				$chatSession.conversation_id || 'N/A',
				'orderOptionsClicked',
				customerSelectedOption
			);
		}
	};

	async function handleClickProduct(
		url: string,
		productName: string,
		selectedProduct: ProductObject
	) {
		window.parent.postMessage({ type: 'flora-navigateProductPage', url }, '*');
		datadogLogs.logger.info(
			`[Conv-ui] Product Selected - brand: ${$chatSession.brand} channel: ${$chatSession.channel} browser_uuid: ${$chatSession.browseruuid} conversation_id: ${$chatSession?.conversation_id} product_selected: ${productName} products_offered: ${JSON.stringify($chatSession.messages[$chatSession.messages.length - 1]?.params?.product_options)}`
		);
		const returnValue = await sendMessage(
			{
				conversation_id: $chatSession.conversation_id,
				brand_code: $chatSession.brand,
				channel: $chatSession.channel,
				message: productName,
				type: 'options',
				params: {
					selected_option: {
						type: 'product_options',
						product_options:
							$chatSession.messages[$chatSession.messages.length - 1]?.params?.product_options,
						selectedProduct: selectedProduct
					},
					typing: false,
					passport: {
						passportStatus: !!$chatSession?.passportEndDate
					},
					customer: {
						email: $chatSession.email,
						contact_id: $chatSession.contactId,
						browser_uuid: $chatSession.browseruuid,
						first: $chatSession.firstName,
						last: $chatSession.lastName
					}
				}
			},
			$chatSession.token
		);
		floraChatEventTracking($chatSession.conversation_id || 'N/A', 'selectedProduct', productName);
	}

	async function handleClickMore(suggestionChosen: string, productName: string) {
		if (!$messageLoading) {
			const showSimilar = suggestionChosen?.toLowerCase() === 'show me more options like this';
			messageLoading.set(true);
			typing.set(true);
			datadogLogs.logger.info(
				`[Conv-ui] Clicked See More Products - brand: ${$chatSession.brand} channel: ${$chatSession.channel} browser_uuid: ${$chatSession.browseruuid} conversation_id: ${$chatSession?.conversation_id} querying_products_like: ${productName} products_offered: ${JSON.stringify($chatSession.messages[$chatSession.messages.length - 1]?.params?.product_options)}`
			);
			const returnValue = await sendMessage(
				{
					conversation_id: $chatSession.conversation_id,
					brand_code: $chatSession.brand,
					channel: $chatSession.channel,
					message: showSimilar
						? `Show me similar items to ${productName}`
						: `Show me products different then ${productName}`,
					type: 'text',
					params: {
						typing: false,
						passport: {
							passportStatus: !!$chatSession?.passportEndDate
						},
						customer: {
							email: $chatSession.email,
							contact_id: $chatSession.contactId,
							browser_uuid: $chatSession.browseruuid,
							first: $chatSession.firstName,
							last: $chatSession.lastName
						}
					}
				},
				$chatSession?.token
			);
			typing.set(false);
			chatSession.update((old) => {
				const updatedSession = {
					...old,
					messages: [
						...clearSuggestionsInMessages(old.messages),
						{
							sender: 'bot',
							message: returnValue?.message,
							type: returnValue?.type,
							params: { ...returnValue?.params, moreProductsRequested: true }
						}
					],
					chatHistory: returnValue?.params.conversation_history || old.chatHistory
				};
				sessionStorage.setItem('conversation', JSON.stringify(updatedSession));
				return updatedSession;
			});
			if ($notificationSoundEnabled) play();
			messageLoading.set(false);
			floraChatEventTracking(
				$chatSession.conversation_id || 'N/A',
				'clickMoreOptions',
				suggestionChosen
			);
		}
	}
	let unsubscribe = () => {};
	unsubscribe = chatSession.subscribe(async (session) => {
		if (session?.brand) {
			unsubscribe();
		}
	});

	onMount(() => {
		const mount = async () => {
			const lastMessage = $chatSession.messages[$chatSession.messages.length - 1];
			if (lastMessage?.params?.product_options?.length) {
				// dont do anything
			} else if (scrollTarget) {
				scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'end' });
			}
		};
		mount();
	});
	afterUpdate(() => {
		const lastMessage = $chatSession.messages[$chatSession.messages.length - 1];
		if (lastMessage?.params?.product_options?.length) {
			// dont do anything.
		} else if (scrollTarget && $chatSession.messages.length) {
			scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'end' });
		}
	});
</script>

<style>
	button {
		all: unset;
		cursor: pointer;
	}
	.message {
		word-wrap: break-word;
		font-family: area-variable, sans-serif;
		font-style: normal;
		font-variation-settings:
			'INKT' 0,
			'slnt' 0,
			'wdth' 100,
			'wght' 100;
		font-weight: 400;
		font-size: 14px;
		line-height: 21px;
		letter-spacing: 0;
		vertical-align: middle;
	}
	.message.customer {
		background: #4169f3;
		color: white;
		align-self: flex-end;
		max-width: 80%;
		margin-left: auto;
		padding-top: 8px;
		padding-right: 12px;
		padding-bottom: 8px;
		padding-left: 12px;
		border-top-left-radius: 14px;
		border-top-right-radius: 14px;
		border-bottom-left-radius: 14px;
	}
	.message.bot {
		flex-grow: 1;
		color: #000;
		align-self: flex-start;
		white-space: pre-wrap;
	}
	.suggestions {
		display: flex;
		flex-wrap: wrap;
		flex-direction: column;
		gap: 8px;
		justify-content: flex-start;
		margin-top: 8px;
		margin-bottom: 8px;
		align-items: flex-start;
	}
	.suggestions-product {
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
		justify-content: flex-start;
		margin-top: 8px;
		margin-bottom: 8px;
		margin-left: 35px;
	}
	.suggestion-button {
		background-color: #f5f5f5;
		color: #000000;
		border: none;
		cursor: pointer;
		max-width: 80%;
		padding-top: 12px;
		padding-right: 20px;
		padding-bottom: 12px;
		padding-left: 20px;
		border-radius: 30px;
		font-family: area-variable, sans-serif;
		font-style: normal;
		font-variation-settings:
			'INKT' 0,
			'slnt' 0,
			'wdth' 100,
			'wght' 100;
		font-weight: 400;
		font-size: 14px;
		line-height: 21px;
		letter-spacing: 0;
		/* text-align: center; */
	}

	.status-card {
		cursor: pointer;
		margin: 0px 10px;
	}
	.status-card.clicked {
		cursor: default;
	}
	.message-container {
		display: flex;
		align-items: flex-start;
		margin-bottom: 10px;
		margin-right: 0.5rem;
		gap: 8px;
	}
	.message-container.bot {
		display: flex;
		align-items: flex-start;
		gap: 8px;
	}
	.message-content {
		display: flex;
		flex-direction: column;
		max-width: 85%;
	}

	.chat-messages {
		flex: 1;
		overflow-y: scroll;
		overflow-x: hidden;

		scrollbar-width: none; /* Firefox */
		-ms-overflow-style: none; /* Internet Explorer 10+ */
	}
	.chat-messages::-webkit-scrollbar {
		display: none; /* Chrome, Safari, and Edge */
	}
	.bot-icon {
		width: 21px;
		height: 24px;
		margin-left: 10px;
	}
	.product-grid2 {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
		gap: 16px;
		width: 85%;
		max-width: 600px;
		margin: auto;
		padding: 16px;
	}
	.customer-order-selection-card {
		align-self: flex-end;
		max-width: 70%;
		margin-left: auto;
		display: flex;
		align-items: center;
		gap: 1rem;
		border: 1px solid #d9d9d9;
		border-radius: 10px;
		padding: 1rem;
		font-family:
			Area Variable,
			Lato,
			LatoMedium,
			sans-serif;
	}

	.customer-order-selection-text {
		display: flex;
		flex-direction: column;
	}

	.customer-order-selection-subtitle {
		font-size: 14px;
		color: #444;
	}
</style>
